import React, { Suspense, useEffect, useRef } from 'react'
import AllRoutes from './routes'
import SkeletonLayout from './components/suspence_ui'
import "./App.css"
import "./styles/font.css";
import "./styles/table.css";
import "./styles/colors.css";
import './i18n'
import useReduxStore from './hooks/useReduxStore';
import useUserLocation from './hooks/useUserLocation';
import { NotificationCountProvider, useNotificationCount } from './context/NotificationContext';
import { UNREADCOUNT } from './repository/notificationRepo';
import { environment } from './env/environment';
import useFaviconColorSwitcher from './hooks/useFaviconColorSwitcher';

const App = () => {
  const { selector: dark_mode } = useReduxStore("dark_mode")
  useEffect(() => {
    document.documentElement.className = dark_mode;
  }, [dark_mode]);
  useUserLocation()
  useFaviconColorSwitcher();
  return (
    <Suspense fallback={<CustomLoader />}>
      <NotificationCountProvider>
        <InnerApp />
      </NotificationCountProvider>
      {/* <Toaster position="top-right" reverseOrder={false} /> */}
    </Suspense>
  )
}

export default App

export const CustomLoader = () => {
  return <><SkeletonLayout /></>
}
const InnerApp = () => {
  const { setNotificationCount } = useNotificationCount();
  const { selector: user } = useReduxStore("auth")
  const clientId = user?.userInfo?._id ?? undefined;

  const getNotificationList = async () => {
    const payload = {
      user_id: clientId
    };
    try {
      let response = await UNREADCOUNT(payload)
      setNotificationCount(response?.unreadedCount)
    } catch (error) {

    }
  }

  const wsRef = useRef(null);
  const reconnectIntervalRef = useRef(null);

  useEffect(() => {
    getNotificationList()
  }, [])

  useEffect(() => {
    if (!clientId) return;

    let isMounted = true;

    function connectWebSocket() {
      if (wsRef.current) wsRef.current.close();

      wsRef.current = new WebSocket(`${environment?.SocketUrl}/?type=client&userId=${clientId}`);

      wsRef.current.onopen = () => {

      };

      wsRef.current.onmessage = (event) => {
        try {
          const details = JSON.parse(event?.data);
          if (details?.event === "notification") {
            getNotificationList()
          }

        } catch (err) {
          console.error("WebSocket message parse error", err);
        }
      };

      wsRef.current.onerror = wsRef.current.onclose = () => {
        if (isMounted) attemptReconnect();
      };
    }

    function attemptReconnect() {
      if (reconnectIntervalRef.current) clearInterval(reconnectIntervalRef.current);
      reconnectIntervalRef.current = setInterval(() => {
        if (
          wsRef.current?.readyState === WebSocket.CLOSED ||
          wsRef.current == null
        ) {
          connectWebSocket();
        }
      }, 5000);
    }

    connectWebSocket();

    return () => {
      isMounted = false;
      if (wsRef.current) {
        wsRef.current.close();
      }
      if (reconnectIntervalRef.current) {
        clearInterval(reconnectIntervalRef.current);
      }
    };
  }, [clientId, setNotificationCount]);

  return <AllRoutes />;
};
